/* tslint:disable */
/* eslint-disable */
/**
 * Syte Products API
 * API services for CRA, Files, and Collaborators
 *
 * The version of the OpenAPI document: v0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * @export
 */
export const SafeguardGroupDtoGroupTypeEnum = {
    TopLevelControl: 'TOP_LEVEL_CONTROL',
    Product: 'PRODUCT',
    NistCsfFunction: 'NIST_CSF_FUNCTION',
    CisImplementationGroup: 'CIS_IMPLEMENTATION_GROUP',
    InsurabilityRating: 'INSURABILITY_RATING',
    InsuranceCategory: 'INSURANCE_CATEGORY',
    A8Outcomes: 'A8_OUTCOMES',
    A8MaturityLevel: 'A8_MATURITY_LEVEL',
    QuickStart: 'QUICK_START'
};
/**
 * @export
 */
export const SafeguardGroupDtoGroupSubTypeEnum = {
    None: 'NONE',
    Product: 'PRODUCT',
    SecurityComponent: 'SECURITY_COMPONENT'
};
/**
 * Check if a given object implements the SafeguardGroupDto interface.
 */
export function instanceOfSafeguardGroupDto(value) {
    let isInstance = true;
    return isInstance;
}
export function SafeguardGroupDtoFromJSON(json) {
    return SafeguardGroupDtoFromJSONTyped(json, false);
}
export function SafeguardGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'assessmentId': !exists(json, 'assessmentId') ? undefined : json['assessmentId'],
        'groupType': !exists(json, 'groupType') ? undefined : json['groupType'],
        'groupSubType': !exists(json, 'groupSubType') ? undefined : json['groupSubType'],
        'groupOrdinal': !exists(json, 'groupOrdinal') ? undefined : json['groupOrdinal'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'listName': !exists(json, 'listName') ? undefined : json['listName'],
    };
}
export function SafeguardGroupDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'identifier': value.identifier,
        'name': value.name,
        'description': value.description,
        'assessmentId': value.assessmentId,
        'groupType': value.groupType,
        'groupSubType': value.groupSubType,
        'groupOrdinal': value.groupOrdinal,
        'title': value.title,
        'listName': value.listName,
    };
}
